module.exports = __webpack_public_path__ + "static/media/leafs.77f29f12.jpg";